import Stack from "@mui/material/Stack";
import Component from "components/Component";
import Options from "components/common/Options";
import StatusBadgeV2 from "components/common/StatusBadgeV2";
import * as featureFlagHooks from "store/hooks/featureFlagHooks";

const roundNumber = (value) => {
  return (value / 1e6).toLocaleString("en-US", {
    maximumFractionDigits: 2,
  });
};

const shortLayerName = (layer, { includeSIR } = {}) => {
  const attachment = includeSIR
    ? layer.effectiveAttachment ?? layer.attachment
    : layer.attachment;
  return `${roundNumber(layer.limit)}x${roundNumber(
    attachment
  )} ($${roundNumber(layer.grossPremium)}m)`;
};

const LayerSelector = ({
  title,
  subtitle,
  loading,
  layers,
  selectedId,
  onSelectId,
}) => {
  const { isOn: includeSIR } = featureFlagHooks.useFeatureFlag(
    "ui/rateChangeSelectorIncludeSIR",
    {
      default: false,
    }
  );

  const options = (layers ?? []).map((layer) => ({
    id: layer.id,
    label: (
      <Stack direction={"row"} alignItems={"center"} gap={1}>
        <StatusBadgeV2 status={layer.status} variant={"icon"} />
        <span>{shortLayerName(layer, { includeSIR })}</span>
      </Stack>
    ),
    selected: selectedId === layer.id,
  }));

  return (
    <Component title={title} subtitle={subtitle} loading={loading}>
      <Options
        items={options}
        onClick={({ id }) => {
          onSelectId(selectedId === id ? null : id);
        }}
        variant={"button"}
      />
    </Component>
  );
};

export default LayerSelector;
